
import { TopSellingProducts } from "../Model/Metric";
import { MetricRepository } from "../Repository/MetricRepository";

export interface GetLowStockProductsUseCase {
  invoke:() => Promise<TopSellingProducts[]>;
}

export class GetLowStockProducts implements GetLowStockProductsUseCase {
  private repo: MetricRepository;
  constructor(_repo: MetricRepository) {
    this.repo = _repo;
  }

  async invoke(){
     
    const getData = await this.repo.getLowStockProducts();
    return getData;
  }
}